import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { blockUi, unBlockUi } from '../../../actions/actionCreator';
import { CASE_STATUS_LEVEL_LOOKUP_TABLE } from '../../../constants';
import { eapiClient, taxonomyHostClient } from '../../../restClient';
import { Translations, disabledCountries, pathsWithCanadaDisabled, shouldFireArtificialEventOnDropdown } from '../../../utils';
import Modal, { ModalBody } from '../../common/Modal';
import { resetCountryInfo, resetCurrencyInfo, setAccountPaperStatement, setBankNameInfo, setCountryInfo, setCountryInfoData, setCurrencyInfo } from '../../createAcase/actions/actionCreator';
import { setLanguageFlag } from '../../layouts/actions/actionCreator';
import Tooltip from '../Tooltip';
import './Dropdown.css';

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dropdownValue: "",
      entityData: [],
      dropDownOpen: false,
      dropDownInvalid: false,
      showPleaseSelect: this.props.showPleaseSelect,
      showTooltip: false,
      test: true,
      showModal: false
    }
    this._prevState = "";
    this.resourceURLData = []
  }

  dropDownVisible = (event) => {
    if (event.currentTarget.name === 'currency') {
      let selectedType = this.props.countryInfo.filter(_countryInfo => {
        return _countryInfo.id === (this.props.formData && this.props.formData.accountType && this.props.formData.accountType.value);
      });
      // DGT-9172 removing filter as requirement
      // let finalselectedType = selectedType
      // if (this.props.formData && !this.props.formData.residency && this.props.formData.accountType && this.props.formData.accountType.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:account:Current') {
      // let arr = finalselectedType[0] && finalselectedType[0].associations.filter(country => country.name !== 'AED')
      // this.props.setCurrencyInfo(selectedType[0].associations);
      // } else if (selectedType[0] && selectedType[0].associations) {
      this.props.setCurrencyInfo(selectedType[0] && selectedType[0].associations);
      // }
    }
    this.setState({ dropDownOpen: !this.state.dropDownOpen });
  }

  toggleTooltiponEnter = (event) => {
    if (event.keyCode === 27) {
      var selector = `[data-tooltip=${this.props.id}]`
      document.querySelectorAll(selector)[0].setAttribute("aria-expanded", false)
      this.setState({
        showTooltip: false
      })
    }
  }

  toggleTooltip = () => {
    var selector = `[data-tooltip=${this.props.id}]`
    document.querySelectorAll(selector)[0].setAttribute("aria-expanded", !this.state.showTooltip)
    this.setState({
      showTooltip: !this.state.showTooltip
    })
  }
  componentWillReceiveProps(nextProps) {
    let resourceUrl = nextProps.resourcesUrl;
    if (nextProps.flag === "true" && this.props.resourcesUrl !== nextProps.resourcesUrl) {
      this.fetchResources(resourceUrl);
      this.props.setLanguageFlag("false");

    }
    // rule for rendering options which is coming from AEM on language change.
    if (this.props.lang !== nextProps.lang && this.props.options !== undefined && nextProps.resourcesUrl !== "/product/taxonomies") {
      this.fetchResources(nextProps.resourcesUrl);
      this.props.setDropdownvalue();
    }
    if (this.props.lang !== nextProps.lang && (this.props.type === "paperStatementFrequency" || this.props.type === "numberOfPaperStatements" || this.props.type === "chequeBooksRequired" || this.props.type === "numberOfChequeBooks" || this.props.type === "chequeBookTypes")) {
      const { country, accountType, currency } = this.props.properties;
      let resourcesUrl = "/product/taxonomies"
      if (nextProps.lang === 'English') {
        resourcesUrl = resourcesUrl + `?country=${country}&account=${accountType}&currency=${currency}`;
      } else if (nextProps.lang === 'Spanish') {
        resourcesUrl = resourcesUrl + `?country=${country}&account=${accountType}&currency=${currency}&lang=es`;
      } else if (nextProps.lang === 'Bahasa') {
        resourcesUrl = resourcesUrl + `?country=${country}&account=${accountType}&currency=${currency}&lang=ba`;
      }
      this.fetchResources(resourcesUrl);
    }

    if (this.props.lang !== nextProps.lang && (this.props.type === "notionallocation")) {
      let resourcesUrl = "/product/taxonomies/notionPoolingCountries"
      if (nextProps.lang === 'English') {
        resourcesUrl = resourcesUrl;
      } else if (nextProps.lang === 'Spanish') {
        resourcesUrl = resourcesUrl + `?lang=es`;
      } else if (nextProps.lang === 'Bahasa') {
        resourcesUrl = resourcesUrl + `?lang=ba`;
      }
      this.fetchResources(resourcesUrl);
    }

    if (this.props.lang !== nextProps.lang && (this.props.properties.editType === 'create-new-cashcon-other-account' || this.props.properties.editType === 'create-new-report-other-account')) {
      //rule
      let apiUrl, apiUrlEchCashCountries, _data, apiUrlNotHsbc;
      let key = window.sessionStorage.getItem("getCurrentDropDown");

      if (nextProps.lang === 'English') {
        apiUrlNotHsbc = "/taxonomies/party/countries"
      }
      else if (nextProps.lang === 'Spanish') {
        apiUrlNotHsbc = "/taxonomies/party/countries" + '?lang=es'
      }
      else if (nextProps.lang === 'Bahasa') {
        apiUrlNotHsbc = "/taxonomies/party/countries" + '?lang=ba'
      }

      if (this.props.formData['bankName'].value !== 'hsbc') {
        taxonomyHostClient(apiUrlNotHsbc)
          .then(({ data }) => {
            //resetting country options
            this.props.setCountryInfo(data.responseData.countryTaxonomy.classificationNodes);
          });
      } else {
        if (this.props.properties.editType === 'create-new-cashcon-other-account') {
          apiUrl = "/product/taxonomies/cashConcentrationCountries"
        } else {
          apiUrl = "/taxonomies/groups/echannel/country"
        }
        if (nextProps.lang === 'English') {
          apiUrlEchCashCountries = apiUrl
        }
        else if (nextProps.lang === 'Spanish') {
          apiUrlEchCashCountries = apiUrl + '?lang=es'
        }
        else if (nextProps.lang === 'Bahasa') {
          apiUrlEchCashCountries = apiUrl + '?lang=ba'
        }
        taxonomyHostClient(apiUrlEchCashCountries)
          .then(({ data }) => {
            //resetting country options
            if (this.props.properties.editType === 'create-new-cashcon-other-account') {
              _data = data.responseData.classificationNodes
            } else {
              _data = data.responseData.countryTaxonomy.classificationNodes
            }
            this.props.setCountryInfo(_data);
          });
      }
    }

    if (this.props.type === 'existingEntity' && (nextProps.existingEntityData.length !== this.props.existingEntityData.length)) {
      document.getElementById(this.getFieldId('otherProfileOwner')).classList.add('noDisplay');
    }
    if (this.props.type === 'otherEntityAccountHolder' && (nextProps.existingEntityData.length !== this.props.existingEntityData.length)) {
      document.getElementById(this.getFieldId('tradingName')).classList.add('noDisplay');
    }
    if (nextProps.formData['otherEntityAccountHolder'] != undefined) {
      if (this.props.type === 'otherEntityAccountHolder' && nextProps.formData['otherEntityAccountHolder'].value === 'other') {
        document.getElementById(this.getFieldId('tradingName')).classList.remove('noDisplay');
      } else {
        document.getElementById(this.getFieldId('tradingName')).classList.add('noDisplay');
      }
    }

    if (this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-basic-details") {
      if (this.props._value !== nextProps._value) {
        this.setValue(nextProps._value || '', nextProps._selectedOptionText || '');
      }
      if (this.props.ResetForm !== nextProps.ResetForm || this.props.CreateNewToggle !== nextProps.CreateNewToggle ||
        this.props.resetData !== nextProps.resetData) {
        this.setState({ dropDownInvalid: false });
      }
    }
    if (this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-documentation-details") {
      if (this.props._value !== nextProps._value) {
        this.setValue(nextProps._value || '', nextProps._selectedOptionText || '');
      }
    }
  }

  setValue = (value, selectedOptionText) => {
    if (value !== "" &&
      value !== undefined) {
      const artificialEvent = {
        target: {
          value: value,
          name: this.props.ddname
        },
        nativeEvent: {
          target: {
            0: { text: selectedOptionText },
            selectedIndex: 0
          }
        }
      };
      this.setDropdownValue(artificialEvent);
    }
  }
  splitOptions = (options) => {
    return options.map(function (option) {
      var splitOptions = option.split('=');
      return {
        id: splitOptions[0],
        description: splitOptions[1]
      };
    });
  }

  // this method add prefix and suffix on field names to match id's
  getFieldId = (fieldName) => {
    return this.props.fieldPrefix !== undefined ? `${this.props.fieldPrefix}${fieldName}Field` : `${fieldName}Field`;
  }

  setDropdownValue = (event) => {
    var setValidation = []
    if (this.props.mandatory === "true") {
      this.validateDropdown(event);
    }

    const dropdownSelection = {
      name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].textContent !== undefined ? event.nativeEvent.target[event.nativeEvent.target.selectedIndex].textContent : event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
      value: event.target.value
    }
    if (event.target.name === 'eChannelType') {
      if (event.target.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:hsbcNet') {
        setValidation = ['surAvailable', 'singleSignOn', 'ipWhitelisting'];
        this.props.validData(setValidation, 'false');
      } else {
        setValidation = ['erpLink'];
        this.props.validData(setValidation, 'false');
      }
    }


    this.props.setDropdownvalue(dropdownSelection, event.target.name);

    this._prevState = this.state.dropdownValue;
    this.setState({ dropdownValue: event.target.value });

    if (this.props.type === "entity" &&
      (this.props.properties.editType === 'add-account-to-case' ||
        this.props.properties.editType === 'capture-product-account-basic-details')) {
      //rule
      const tempRefCaseId = event.target.value;
      eapiClient("/product/account/case/" + tempRefCaseId + "/tempRef")
        .then(({ data }) => {
          this.props.properties.setTempRefForAccount(data.responseData.tempRefrenceId);
        });
    }
    if (this.props.properties.editType === "add-echannel-to-case" &&
      this.props.properties.pathname === '/case-body/create-new-echannel' && this.props.formData.newEchannel && !this.props.formData.tempRefrenceId) {
      eapiClient("/product/echannel/case/" + this.props.properties.tempRefCaseId + "/tempRef")
        .then(({ data }) => {
          this.props.properties.setTempRefForAccount(data.responseData.tempRefrenceId);
        });
    }

    if (event.target.name === 'country' &&
      (this.props.properties.editType === 'add-account-to-case' ||
        this.props.properties.editType === 'capture-product-account-basic-details')) {
      //rule
      let apiURL;
      if (this.props.lang === 'English') {
        apiURL = "/product/countryInfo/" + event.target.value
      }
      if (this.props.lang === 'Spanish') {
        apiURL = "/product/countryInfo/" + event.target.value + '?lang=es'
      }
      if (this.props.lang === 'Bahasa') {
        apiURL = "/product/countryInfo/" + event.target.value + '?lang=ba'
      }
      taxonomyHostClient(apiURL)
        .then(({ data }) => {
          this.props.setCountryInfo(data.responseData.associations);
          //resetting accountType and currency options
          this.props.setDropdownvalue("", "accountType");
          this.props.setDropdownvalue("", "currency");
          if (this._prevState !== "" && this._prevState !== dropdownSelection.value) {
            this.props.resetCurrencyInfo();
          }
        });
    }

    if (event.target.name === 'bankName' && (this.props.properties.editType === 'create-new-cashcon-other-account' || this.props.properties.editType === 'create-new-report-other-account')) {
      //rule
      let apiUrl, apiUrlEchCashCountries, _data, apiUrlNotHsbc;

      if (this.props.lang === 'English') {
        apiUrlNotHsbc = "/taxonomies/party/countries"
      }
      else if (this.props.lang === 'Spanish') {
        apiUrlNotHsbc = "/taxonomies/party/countries" + '?lang=es'
      }
      else if (this.props.lang === 'Bahasa') {
        apiUrlNotHsbc = "/taxonomies/party/countries" + '?lang=ba'
      }

      let key = window.sessionStorage.getItem("getCurrentDropDown");
      if (event.target.value !== 'hsbc') {
        taxonomyHostClient(apiUrlNotHsbc)
          .then(({ data }) => {
            //resetting country options
            this.props.setCountryInfo(data.responseData.countryTaxonomy.classificationNodes);
            this.props.setDropdownvalue("", "country");
            this.props.setFieldValidtionState("country", "invalid");
          });
      } else {
        if (this.props.properties.editType === 'create-new-cashcon-other-account') {
          apiUrl = "/product/taxonomies/cashConcentrationCountries"
        } else {
          apiUrl = "/taxonomies/groups/echannel/country"
        }
        if (this.props.lang === 'English') {
          apiUrlEchCashCountries = apiUrl
        }
        else if (this.props.lang === 'Spanish') {
          apiUrlEchCashCountries = apiUrl + '?lang=es'
        }
        else if (this.props.lang === 'Bahasa') {
          apiUrlEchCashCountries = apiUrl + '?lang=ba'
        }
        taxonomyHostClient(apiUrlEchCashCountries)
          .then(({ data }) => {
            //resetting country options
            if (this.props.properties.editType === 'create-new-cashcon-other-account') {
              _data = data.responseData.classificationNodes
            } else {
              _data = data.responseData.countryTaxonomy.classificationNodes
            }
            this.props.setCountryInfo(_data);
            this.props.setDropdownvalue("", "country");
          });
      }
    }

    if (event.target.name === 'country' &&
      (this.props.properties.editType === 'create-new-notionalPool-other-account' ||
        'create-new-cashcon-other-account' || 'create-new-ie-other-account')) {
      let selectedBankName = this.props.countryInfoData.filter(_countryInfo => {
        return _countryInfo.id === event.target.value;
      });
      this.props.setBankNameInfo(selectedBankName);
      if (this.props.properties.editType === "capture-product-account-basic-details") {
        this.props.setAccountPaperStatement(true);
      }
    }
    if (event.target.name === 'accountType') {
      //rule
      let selectedType = this.props.countryInfo.filter(_countryInfo => {
        return _countryInfo.id === event.target.value;
      });
      this.props.setDropdownvalue("", "currency");
      this.props.setCurrencyInfo(selectedType[0] && selectedType[0].associations);
      if (this.props.properties.editType === "capture-product-account-basic-details") {
        this.props.setAccountPaperStatement(true);
      }
    }
    if (event.target.name === 'currency') {
      if (this.props.properties.editType === "capture-product-account-basic-details") {
        this.props.setAccountPaperStatement(true);
      }
    }
    if (event.target.name === 'chequeBookTypes') {
      //rule
      if (event.target.value === 'Not Required') {
        document.getElementById(this.getFieldId('numberOfChequeBooks')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('customisedRequirement')).classList.add('noDisplay');
      } else if (event.target.value === 'Standard') {
        document.getElementById(this.getFieldId('numberOfChequeBooks')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('customisedRequirement')).classList.add('noDisplay');
      } else if (event.target.value === 'Custom') {
        document.getElementById(this.getFieldId('numberOfChequeBooks')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('customisedRequirement')).classList.remove('noDisplay');
      }
    }

    if (event.target.name === 'eChannelType') {
      // rules - toggle visibility of form fields based on E-Channel type
      // visibility rules for new and existing E-Channels are in formFieldsVisibilityRules.js - lines 25 to 40
      let value = event.target.value.substring((event.target.value.lastIndexOf(":") + 1), event.target.value.length);
      if (value === 'hsbcNet') {
        document.getElementById(this.getFieldId('surAvailable')).classList.remove('noDisplay');
        // document.getElementById(this.getFieldId('eChannelIdOptional')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('singleSignOn')) && document.getElementById(this.getFieldId('singleSignOn')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('ipWhitelisting')) && document.getElementById(this.getFieldId('ipWhitelisting')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('erpLink')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('swiftBIC')).classList.add('noDisplay');
      } else if (value === 'swiftNet') {
        //document.getElementById(this.getFieldId('eChannelIdOptional')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('erpLink')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('swiftBIC')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('surAvailable')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('sur')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('singleSignOn')) && document.getElementById(this.getFieldId('singleSignOn')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('ipWhitelisting')) && document.getElementById(this.getFieldId('ipWhitelisting')).classList.add('noDisplay');
      }
      else {
        document.getElementById(this.getFieldId('erpLink')).classList.remove('noDisplay');
        //document.getElementById(this.getFieldId('eChannelIdOptional')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('surAvailable')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('sur')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('swiftBIC')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('singleSignOn')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('ipWhitelisting')).classList.add('noDisplay');
      }
    }

    if (event.target.name === 'communicationMedium') {
      //rule
      if (event.target.value === 'mail') {
        document.getElementById(this.getFieldId('franceAddress')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('faxNumber')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('phoneNumber')).classList.add('noDisplay');
      } else if (event.target.value === 'phone') {
        document.getElementById(this.getFieldId('phoneNumber')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('franceAddress')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('faxNumber')).classList.add('noDisplay');

      }
      else if (event.target.value === 'fax') {
        document.getElementById(this.getFieldId('faxNumber')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('franceAddress')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('phoneNumber')).classList.add('noDisplay');
      }
    }
    if (event.target.name === 'paperStatementFrequency') {
      if (event.target.value === 'NR' || event.target.value === '') {
        document.getElementById(this.getFieldId('numberOfPaperStatements')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('perfferedDate')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('deliverTo')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('attentionOf')).classList.add('noDisplay');
      } else {
        document.getElementById(this.getFieldId('numberOfPaperStatements')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('perfferedDate')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('deliverTo')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('attentionOf')).classList.remove('noDisplay');

      }
    }
    if (event.target.name === 'reverseSweepOption' && document.getElementById(this.getFieldId('reverseSweepHolidaySkip')) !== null) {
      //rule
      if (event.target.value === 'yes') {
        document.getElementById(this.getFieldId('reverseSweepHolidaySkip')).classList.remove('noDisplay');
      } else {
        document.getElementById(this.getFieldId('reverseSweepHolidaySkip')).classList.add('noDisplay');
      }

    }
    if (event.target.name === 'title') {
      if (event.target.value === 'other') {
        document.getElementById(this.getFieldId('other')).classList.remove('noDisplay');
      }
      else {
        document.getElementById(this.getFieldId('other')).classList.add('noDisplay');
      }
    }
    if (event.target.name === 'bankName' && this.props.properties.editType === 'create-new-report-other-account') {
      if (event.target.value === 'other') {
        document.getElementById(this.getFieldId('otherBankName')).classList.remove('noDisplay');
      }
      else {
        document.getElementById(this.getFieldId('otherBankName')).classList.add('noDisplay');
      }
    }
    if (event.target.name === 'productType' && this.props.properties.editType === 'product-requests-form') {
      if (event.target.value === 'cs-other-product') {
        document.getElementById(this.getFieldId('otherProductValue')).classList.remove('noDisplay');
      }
      else {
        document.getElementById(this.getFieldId('otherProductValue')).classList.add('noDisplay');
      }
    }
    if (event.target.name === 'country' && this.props.properties.editType === 'product-requests-form') {
      if (event.target.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:Other:EN') {
        document.getElementById(this.getFieldId('otherCountryValue')).classList.remove('noDisplay');
      }
      else {
        document.getElementById(this.getFieldId('otherCountryValue')).classList.add('noDisplay');
      }
    }
    if (event.target.name === 'bankName' && this.props.properties.editType === 'create-new-cashcon-other-account') {
      if (event.target.value === "hsbc") {
        document.getElementById(this.getFieldId('addressLine1')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('addressLine2')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('addressLine3')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('city')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('state')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('postCode')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('otherBankName')).classList.add('noDisplay');
      } else {
        document.getElementById(this.getFieldId('addressLine1')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('addressLine2')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('addressLine3')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('city')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('state')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('postCode')).classList.remove('noDisplay');
        event.target.value === "other" ? document.getElementById(this.getFieldId('otherBankName')).classList.remove('noDisplay') : document.getElementById(this.getFieldId('otherBankName')).classList.add('noDisplay');
      }
    }
    if (event.target.name === 'otherEntityProfileOwner') {
      if (event.target.value === 'other') {
        document.getElementById(this.getFieldId('otherProfileOwner')).classList.remove('noDisplay');
        setValidation = ['otherProfileOwner'];
        this.props.validData(setValidation, 'false');
      }
      else {
        document.getElementById(this.getFieldId('otherProfileOwner')).classList.add('noDisplay');
      }
    }
    if (event.target.name === 'otherEntityAccountHolder') {
      if (event.target.value === 'other') {
        document.getElementById(this.getFieldId('tradingName')).classList.remove('noDisplay');
        setValidation = ['tradingName'];
        this.props.validData(setValidation, 'false');
      }
      else {
        document.getElementById(this.getFieldId('tradingName')).classList.add('noDisplay');
      }
    }
    if (event.target.name === 'status') {
      if (event.target.value === 'urn:hsbc:cmb:gdocs:cases:taxonomies:status:complete' && this.state.dropdownValue !== '' && this.state.dropdownValue !== 'urn:hsbc:cmb:gdocs:cases:taxonomies:status:complete') {
        this.toggleDialog();
      }
    }
  }

  validateDropdown = (event) => {
    if (this.props.mandatory === "true") {
      if (event.target.value === '' || event.target.value === 'Please select') {
        this.setState({ dropDownInvalid: true });
        this.props.setFieldValidtionState(event.target.name, "invalid");
      }
      else {
        this.setState({ dropDownInvalid: false });
        this.props.setFieldValidtionState(event.target.name, "valid");
      }
    }
  }

  handleBlur = (event) => {
    this.validateDropdown(event);
    this.setState({ dropDownOpen: false });
  }

  fetchResources = (resourcesUrl) => {
    if (this.props.isRepeatingComponentWithSameResourceUrl) {
      this.props.cachedResourceData && this.classifyResources(this.props.cachedResourceData)
    }
    else if (resourcesUrl !== undefined) {
      this.props.showLoaderOnFetchApiResource && this.props.blockUi && this.props.blockUi()
      taxonomyHostClient(resourcesUrl)
        .then(({ data }) => {
          this.classifyResources(data);
          this.props.showLoaderOnFetchApiResource && this.props.unBlockUi && this.props.unBlockUi()
        });
    }
    else {
      if (this.props.options) {
        this.classifyResources(this.props.options);
      }
    }
  }

  classifyResources(data) {
    // this.setState({
    //   data: data.responseData[this.props.ddname].classificationNodes
    // });

    if (this.props.type === "country") {
      var countrydata = data.responseData.countryTaxonomy !== undefined ? data.responseData.countryTaxonomy.classificationNodes : data.responseData.classificationNodes;
      this.setState({
        data: countrydata
      });

      const { country, accountType } = this.props.formData;
      if (accountType !== undefined) {
        let apiURL;
        if (this.props.lang === 'English') {
          apiURL = "/product/countryInfo/" + country.value
        }
        if (this.props.lang === 'Spanish') {
          apiURL = "/product/countryInfo/" + country.value + '?lang=es'
        }
        if (this.props.lang === 'Bahasa') {
          apiURL = "/product/countryInfo/" + country.value + '?lang=ba'
        }
        taxonomyHostClient(apiURL)
          .then(({ data }) => {
            var selectedType = data.responseData.associations.filter(_countryInfo => {
              return _countryInfo.id === accountType.value;
            });
            let currency = selectedType[0] !== undefined ? selectedType[0].associations : [];
            this.props.setCountryInfo(data.responseData.associations);
            this.props.setCurrencyInfo(currency);
          });
      }
    }
    else if (this.props.type === "notionallocation") {
      var countrydataNotionallocation = data.responseData.classificationNodes;
      this.setState({ data: countrydataNotionallocation });
    } else if (this.props.type === "relationshipBank") {
      var countrydatarelationshipBank = data.responseData.countryTaxonomy.classificationNodes;
      this.setState({ data: countrydatarelationshipBank })
    } else if (this.props.type === "currency") {
      var currencydata = data.responseData.currencyTaxonomy.classificationNodes;
      this.setState({
        data: currencydata
      });

    } else if (this.props.type === "otherAccountCurrency") {
      var currencydatas = data.responseData.classificationNodes;
      if (this.props.properties.setCurrency !== undefined && this.props.properties.setCurrency !== '') {
        var _currencydata = currencydatas.filter(item => {
          if (item.name === this.props.properties.setCurrency) {
            return item;
          }
        })
        this.setState({
          data: _currencydata
        });
      } else {
        this.setState({
          data: currencydatas
        });
      }
    } else if (this.props.type === "otherAccountCountry") {
      var countrydata1 = data.responseData.classificationNodes;
      if (this.props.properties.setCountry !== undefined && this.props.properties.setCountry !== '') {
        var _countrydata = countrydata1.filter(item => {
          if (item.id === this.props.properties.setCountry) {
            return item;
          }
        })
      }
      this.props.setCountryInfoData(countrydata1);
      let selectedBankName = this.props.countryInfoData.filter(_countryInfo => {
        return _countryInfo.id === this.props.value;
      });
      this.props.setBankNameInfo(selectedBankName);
      if (this.props.properties.setCountry !== undefined) {
        this.setState({
          data: _countrydata
        });
      }
      else {
        this.setState({
          data: countrydata1
        });
      }
    } else if (this.props.type === "achCountry") {
      var achCountry = data.responseData.classificationNodes;
      if (this.props.properties.setCountry !== undefined && this.props.properties.setCountry !== '') {
        var _countrydata = achCountry.filter(item => {
          if (item.id === this.props.properties.setCountry) {
            return item;
          }
        })
      }
      if (this.props.properties.setCountry !== undefined) {
        this.setState({
          data: _countrydata
        });
      } else {
        this.setState({
          data: achCountry
        });
      }
    } else if (this.props.type === "otherAccountAchCurrency") {
      var achCurrency = data.responseData.others;
      if (this.props.properties.setCountry !== undefined && this.props.properties.setCountry !== '') {
        var _currencydata = achCurrency.filter(item => {
          //let selectedCurreny = this.props.properties.setCountry.split(':');
          if (item.lid === this.props.properties.setCountry) {
            return item;
          }
        })
      }
      if (this.props.properties.setCountry !== undefined) {
        this.setState({
          data: _currencydata
        });
      } else {
        this.setState({
          data: achCurrency
        });
      }
    } else if (this.props.type === "currencyOtherAccount") {
      var currencyOtherAccountdata = data.responseData.currencyTaxonomy.classificationNodes;
      this.setState({
        data: currencyOtherAccountdata
      });

    } else if (this.props.type === "account") {
      var accountdata = data.responseData.accountTypeTaxonomy.classificationNodes;
      this.setState({
        data: accountdata
      });
    } else if (this.props.type === "accountHolder") {
      var accountholderdata = data.responseData.accountTypeTaxonomy.classificationNodes;
      this.setState({
        data: accountholderdata
      });
    } else if (this.props.type === "businessSegment") {
      var accountholderdataBusinessSegment = data.responseData.classificationNodes;
      this.setState({
        data: accountholderdataBusinessSegment
      });
    } else if (this.props.type === "eChannelType") {
      var accountholderdataEchannelType = data.responseData.echannelTypeTaxonomy.classificationNodes;
      this.setState({
        data: accountholderdataEchannelType
      });
    } else if (this.props.type === "glsproductType") {
      var glsproductypelist = this.props.options.map(function (option, index) {
        var splitOptions = option.split('=');
        return {
          id: splitOptions[0],
          description: splitOptions[1]
        };
      });
      this.setState({
        data: glsproductypelist
      });
    } else if (this.props.type === "communicationMedium") {
      var communicationMediumList = this.props.options.map(function (option, index) {
        var splitOptions = option.split('=');
        return {
          id: splitOptions[0],
          description: splitOptions[1]
        };
      });
      this.setState({
        data: communicationMediumList
      });
    } else if (this.props.type === "accountTitle") {
      const accountTitleOptions = this.splitOptions([...this.props.options]);
      this.setState({
        data: accountTitleOptions
      });
    } else if (this.props.type === "paperStatementFrequency") {
      const paperStatementsFrequency = data.responseData.paperStatementsFrequency;
      this.setState({
        data: paperStatementsFrequency
      });
      /*find a better place for this piece of code*/
      if (paperStatementsFrequency.length === 0) {
        document.getElementById(this.getFieldId('paperStatementFrequency')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('numberOfPaperStatements')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('perfferedDate')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('deliverTo')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('attentionOf')).classList.add('noDisplay');
      }
    } else if (this.props.type === "numberOfPaperStatements") {
      const numberOfPaperStatements = data.responseData.numberOfPaperStatements;
      this.setState({
        data: numberOfPaperStatements
      });
    } else if (this.props.type === "numberOfChequeBooks") {
      const numberOfChequeBooks = data.responseData.numberOfChequeBooks;
      this.setState({
        data: numberOfChequeBooks
      });
    } else if (this.props.type === "chequeBookTypes") {
      const chequeBookTypes = data.responseData.chequeBookTypes;
      this.setState({
        data: chequeBookTypes
      });
      /*find a better place for this piece of code*/
      if (chequeBookTypes.length === 0) {
        document.getElementById(this.getFieldId('chequeBookTypes')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('numberOfChequeBooks')).classList.add('noDisplay');
        const droplist = { name: '', value: '' }
        this.props.setDropdownvalue(droplist, "chequeBookTypes");
      }
    } else if (this.props.type === "telephoneCountryCode") {
      const telephoneCountryCode = data.responseData.classificationNodes;
      this.setState({
        data: telephoneCountryCode
      });
    } else if (this.props.type === "faxCountryCode") {
      const faxCountryCode = data.responseData.classificationNodes;
      this.setState({
        data: faxCountryCode
      });
    } else if (this.props.type === "lendingLimitBreachAction") {
      this.setState({
        data: this.splitOptions([...this.props.options])
      });
    } else if (this.props.type === "borrowingLimitBreachAction") {
      this.setState({
        data: this.splitOptions([...this.props.options])
      });
    } else if (this.props.type === "sweepTimeZone") {
      this.setState({
        data: data.responseData.classificationNodes
      });
    } else if (this.props.type === "glsCountries") {
      this.setState({
        data: data.responseData.classificationNodes
      });
    } else if (this.props.type === "gdocsTerms") {
      this.setState({
        data: data.responseData.classificationNodes[0].associations
      });
    } else if (this.props.type === "productType") {
      var productType = data.responseData.classificationNodes
      productType.forEach(item => item.id = item.code)
      this.setState({
        data: productType
      });
    }
    else if (this.props.type === "cancelationReason") {
      this.setState({
        data: this.props.options
      });
    } else if (this.props.resourcesUrl !== undefined && this.props.options === undefined) {
      // final fallback- if no type is matched then this will look for response data
      if (data && data.responseData && data.responseData.classificationNodes) {
        this.setState({
          data: data.responseData.classificationNodes
        });
      }
    } else if (this.props.options !== undefined) {
      // final fallback- if no type is matched then this will look for aem options
      this.setState({
        data: this.splitOptions([...this.props.options])
      });
    }
  }

  componentDidMount() {
    let resourcesUrl = this.props.resourcesUrl;
    //passing extra params because paper statement needs to know country, accountType, currency
    if (resourcesUrl !== undefined && (this.props.type === "paperStatementFrequency" || this.props.type === "numberOfPaperStatements" || this.props.type === "chequeBooksRequired" || this.props.type === "numberOfChequeBooks" || this.props.type === "chequeBookTypes")) {
      const { country, accountType, currency } = this.props.properties;
      if (this.props.lang === 'English') {
        resourcesUrl = resourcesUrl + `?country=${country}&account=${accountType}&currency=${currency}`;
      } else if (this.props.lang === 'Spanish') {
        resourcesUrl = resourcesUrl + `?country=${country}&account=${accountType}&currency=${currency}&lang=es`;
      } else if (this.props.lang === 'Bahasa') {
        resourcesUrl = resourcesUrl + `?country=${country}&account=${accountType}&currency=${currency}&lang=ba`;
      }
    }
    // if(resourcesUrl !== undefined && this.props.type ==='country' && (this.props.properties.editType === 'create-new-report-other-account')){
    //   let fromDataFromSession = window.sessionStorage.getItem('previousPageStateLevel2');
    //   let parseData = JSON.parse(fromDataFromSession);
    //     if(parseData.formData['otherAccountHolder'] === true){
    //           resourcesUrl = '/taxonomies/party/countries'
    //     }
    // }
    this.fetchResources(resourcesUrl);
    if (this.props._value !== undefined) {
      this.setState({ dropdownValue: this.props._value });
    }

    if (this.props.mode === 'edit' && (this.props.properties.editType === 'create-new-cashcon-other-account' || this.props.properties.editType === 'create-new-report-other-account')) {
      //rule
      let apiUrl, apiUrlEchCashCountries, _data, apiUrlNotHsbc;
      let key = window.sessionStorage.getItem("getCurrentDropDown");

      if (this.props.lang === 'English') {
        apiUrlNotHsbc = "/taxonomies/party/countries"
      }
      else if (this.props.lang === 'Spanish') {
        apiUrlNotHsbc = "/taxonomies/party/countries" + '?lang=es'
      }
      else if (this.props.lang === 'Bahasa') {
        apiUrlNotHsbc = "/taxonomies/party/countries" + '?lang=ba'
      }

      if (this.props.formData['bankName'].value !== 'HSBC') {
        taxonomyHostClient(apiUrlNotHsbc)
          .then(({ data }) => {
            //resetting country options
            this.props.setCountryInfo(data.responseData.countryTaxonomy.classificationNodes);
          });
      } else {
        if (this.props.properties.editType === 'create-new-cashcon-other-account') {
          apiUrl = "/product/taxonomies/cashConcentrationCountries"
        } else {
          apiUrl = "/taxonomies/groups/echannel/country"
        }
        if (this.props.lang === 'English') {
          apiUrlEchCashCountries = apiUrl
        }
        else if (this.props.lang === 'Spanish') {
          apiUrlEchCashCountries = apiUrl + '?lang=es'
        }
        else if (this.props.lang === 'Bahasa') {
          apiUrlEchCashCountries = apiUrl + '?lang=ba'
        }
        taxonomyHostClient(apiUrlEchCashCountries)
          .then(({ data }) => {
            //resetting country options
            if (this.props.properties.editType === 'create-new-cashcon-other-account') {
              _data = data.responseData.classificationNodes
            } else {
              _data = data.responseData.countryTaxonomy.classificationNodes
            }
            this.props.setCountryInfo(_data);
          });
      }
    }
    // simulating change event if data is pre-populated [only when requried]
    if (this.props._value !== "" &&
      this.props._value !== undefined &&
      shouldFireArtificialEventOnDropdown(this.props.ddname, this.props.type)) {
      const artificialEvent = {
        target: {
          value: this.props._value,
          name: this.props.ddname
        },
        nativeEvent: {
          target: {
            0: { text: this.props._selectedOptionText },
            selectedIndex: 0
          }
        }
      };
      this.setDropdownValue(artificialEvent);
    }
  }

  toggleDialog = () => {
    this.setState({
      showModal: !this.state.showModal
    })
  }

  checkForDropdownValue = (optionsData) => {
    if (optionsData !== undefined && optionsData.length !== 0) {
      let valueMatched = optionsData.filter((item) => (
        this.props.value && this.props.value === (item.id || item.value || item.hsbcEntity)
      ))
      return valueMatched.length === 0 ? true : false;
    }
  }

  checkDisabled = (caseId, entityName) => {
    if (CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId].status] > 2 || this.props.properties.currentCaseId !== caseId && this.props.properties.editType === 'create-ach-other-account') {
      return true
    }
    if (this.props.productType && this.props.productType === "cashFlowForecasting" && this.props.productList) {
      return Boolean(this.props.productList.findIndex(product => product.cffAgent.name === entityName) >= 0)
    }
    return false
  }

  render() {
    let caseOptionsData, optionsData, accountTypeOptions, currencyOptions, caseOptionsGLSData, currencyOtherAccountOptions, bankNameOptions, existingEntityData, bankData, countryOptions, feeOptions;
    if (this.props.type === "entity") {
      caseOptionsData = this.props.cases;
    }
    else if (this.props.type === "existingEntity" || this.props.type === 'otherEntityAccountHolder') {
      existingEntityData = this.props.existingEntityData;
    }
    else if (this.props.type === 'entityBankName') {
      bankData = this.props.bankData
    }
    else if (this.props.type === "glsAgent") {
      caseOptionsGLSData = this.props.cases;
      //removed  && this.props.title === "Account Type" on below line
    } else if (this.props.type === "accountType") {
      accountTypeOptions = this.props.countryInfo;
      // removed  && this.props.title === "Currency"
    } else if (this.props.type === "currencyType") {
      currencyOptions = this.props.currencyInfo;
    } else if (this.props.type === "bankName") {
      bankNameOptions = this.props.bankNameInfo
    } else if (this.props.type === "currencyOtherAccount") {
      currencyOtherAccountOptions = this.state.data;
    } else if (this.props.type === "otherAccountCountry" && this.props.properties.editType === 'create-new-cashcon-other-account') {
      countryOptions = this.props.countryInfo;
    } else if (this.props.type === 'country' && this.props.properties.editType === 'create-new-report-other-account') {
      countryOptions = this.props.countryInfo;
    }
    else if (this.props.type === 'sowFee_Type') {
      feeOptions = this.props.taxonomies;
    } else {
      optionsData = this.state.data;
    }

    const isOnPathWithCanadaDisabled = this.props.properties && this.props.properties.pathname &&
      pathsWithCanadaDisabled.some(url => this.props.properties.pathname.includes(url));


    let optionsJsx = [];
    if (optionsData) {
      let _optionsData = optionsData;

      if (this.props.type === 'eChannelType' && this.props.properties.pathname.includes("isEchannelRestricted")) {
        _optionsData = optionsData.filter(eChannel => eChannel.name === "HSBCnet");
      }
      const isFullCountryList = _optionsData.length > 100;
      optionsJsx = _optionsData.map((item, index) => (
        <option key={index} selected={this.props.value && this.props.value === (item.id || item.value) ? true : false}
          className={
            classnames((!isFullCountryList && isOnPathWithCanadaDisabled && disabledCountries.indexOf(item.name) >= 0) ? 'gdocs-dropdown-value-disabled ' : '', this.state.dropdownValue === '{item.description}' ? 'ActiveCls' : `option${index}`)
          }
          value={item.id || item.value}
          disabled={(!isFullCountryList && isOnPathWithCanadaDisabled && disabledCountries.indexOf(item.name) >= 0) ? true : false}
        >
          {item.description || item.name}
        </option>)
      )
    } else if (feeOptions) {
      optionsData = feeOptions;
      optionsJsx = feeOptions.map((item, index) => (<option key={index}
        selected={this.props.value && this.props.value === item.value ? true : false}
        value={item.value}>
        {item.name}
      </option>)
      )
    } else if (currencyOptions) {
      optionsData = currencyOptions;
      optionsJsx = currencyOptions.map((item, index) => (<option key={index}
        selected={this.props.value && this.props.value === item.id ? true : false}
        value={item.id}>
        {item.name}
      </option>)
      )
    } else if (currencyOtherAccountOptions) {
      optionsData = currencyOtherAccountOptions;
      optionsJsx = currencyOtherAccountOptions.map((item, index) => (<option key={index}
        selected={this.props.value && this.props.value === item.id ? true : false}
        value={item.id}>
        {item.alphabeticalCode}
      </option>)
      )
    } else if (accountTypeOptions) {
      optionsData = accountTypeOptions;
      optionsJsx = accountTypeOptions.map((item, index) => (<option key={index}
        selected={this.props.value && this.props.value === item.id ? true : false}
        value={item.id}>
        {item.name}
      </option>)
      )
    } else if (bankNameOptions) {
      optionsData = bankNameOptions;
      optionsJsx = bankNameOptions.map((item, index) => (<option key={index}
        selected={this.props.value && this.props.value === item.hsbcEntity ? true : false}
        value={item.hsbcEntity}>
        {item.hsbcEntity}
      </option>)
      )
    } else if (countryOptions) {
      optionsData = countryOptions;
      const isFullCountryList = optionsData.length > 100;
      optionsJsx = countryOptions.map((item, index) => (<option key={index}
        selected={this.props.value && this.props.value === (item.id) ? true : false}
        disabled={(!isFullCountryList && isOnPathWithCanadaDisabled ? ((this.props.formData && this.props.formData.bankName && this.props.formData.bankName.value.toUpperCase() === 'HSBC' &&
          disabledCountries.indexOf(item.name) >= 0) ? true : false) : false)}
        className={
          classnames((!isFullCountryList && isOnPathWithCanadaDisabled ? ((this.props.formData && this.props.formData.bankName && this.props.formData.bankName.value.toUpperCase() === 'HSBC' &&
            disabledCountries.indexOf(item.name) >= 0) ? 'gdocs-dropdown-value-disabled ' : '') : ''))
        }
        value={item.id}>
        {item.name}
      </option>)
      )
    }
    else if (caseOptionsData) {
      for (const caseId in this.props.cases) {
        let visibilityCss = ''
        if (CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId].status] <= 4) {
          let visibilityCss = classnames("false", {
            'gdocs-dropdown-value-disabled': CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId].status] > 2
          });
          let visibilityCase = ""
          if (this.props.properties.currentCaseId !== undefined && this.props.properties.editType === 'create-ach-other-account') {
            visibilityCase = classnames("false", {
              'gdocs-dropdown-value-disabled': this.props.properties.currentCaseId !== caseId
            });
          }
          optionsJsx.push((<option key={caseId}
            className={visibilityCss, visibilityCase, (this.props.productType && this.props.productType === "cashFlowForecasting" && this.checkDisabled(caseId, this.props.cases[caseId].entityName) && 'gdocs-dropdown-value-disabled')}
            selected={this.props.value && this.props.value === caseId ? true : false}
            value={caseId}
            disabled={this.checkDisabled(caseId, this.props.cases[caseId].entityName)}>
            {this.props.cases[caseId].entityName}
          </option>)
          );
        }
      }
    } else if (existingEntityData) {
      for (let existingCase in this.props.existingEntityData) {
        if (existingCase !== 'remove') {
          optionsJsx.push((<option key={this.props.existingEntityData[existingCase].id}
            selected={this.props.value && this.props.value === this.props.existingEntityData[existingCase].id ? true : false}
            value={this.props.existingEntityData[existingCase].id}>
            {this.props.existingEntityData[existingCase].existingEntityName}
          </option>)
          );
        }
      }

    } else if (bankData) {
      for (let bank in this.props.bankData) {
        if (bank !== 'remove') {
          optionsJsx.push((<option key={this.props.bankData[bank].id}
            selected={this.props.value && this.props.value === this.props.bankData[bank].value ? true : false}
            value={this.props.bankData[bank].value}>
            {this.props.bankData[bank].name}
          </option>)
          );
        }
      }
    }
    else if (caseOptionsGLSData) {
      for (var caseId1 in this.props.cases) {
        if (CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId1].status] <= 4) {
          let visibilityCss = classnames("false", {
            'gdocs-dropdown-value-disabled': CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId1].status] > 2
          });
          optionsJsx.push((<option key={caseId1}
            selected={this.props.value && this.props.value === this.props.cases[caseId1].entityId ? true : false}
            className={visibilityCss}
            value={this.props.cases[caseId1].entityId}
            disabled={CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId1].status] > 2 ? true : false}>
            {this.props.cases[caseId1].entityName}
          </option>)
          );
        }
      }
    }
    if (this.props.properties && this.props.properties.editType === "gls-sow-add-account" && this.props.taxonomies[this.props.type]) {
      const isFullCountryList = this.props.taxonomies[this.props.type].length > 100;
      optionsJsx = this.props.taxonomies[this.props.type].map((item, index) => {
        return <option key={"taxo-" + index}
          selected={(this.props.value && (this.props.value === item.id || this.props.value === item.value)) ? true : false}
          disabled={(!isFullCountryList && disabledCountries.indexOf(item.name) >= 0) ? true : false}
          className={
            classnames((!isFullCountryList && disabledCountries.indexOf(item.name) >= 0) ? 'gdocs-dropdown-value-disabled ' : '')
          }
          value={item.id} >
          {item.name}
        </option >
      })
    }

    const dropDownCss = classnames("dropDownList", {
      "gdocs-input-error": this.state.dropDownInvalid === true
    });

    return (
      <div className="dropdown-container" >
        <div className="dropDownArrowComponent">
          <span aria-hidden="true" className="alignVerLine">|</span>
          <span aria-hidden="true" className={this.state.dropDownOpen === true ? 'icon icon-chevron-up-small' : 'icon icon-chevron-down-small'}></span>
        </div>
        <select className={dropDownCss}
          id={this.props.id}
          name={this.props.ddname}
          disabled={this.props.disabled}
          onClick={this.dropDownVisible}
          onBlur={this.handleBlur}
          aria-describedby={this.props.ddname + "-error"}
          onChange={this.setDropdownValue}>
          <option value="" aria-label="Please select" disabled={!(this.props.value === undefined || this.props.value === "" || this.checkForDropdownValue(optionsData))} selected={this.props.value === undefined || this.props.value === "" || this.checkForDropdownValue(optionsData)}>{this.props.pleaseSelectcValue}</option>
          {optionsJsx}
        </select>
        {
          (this.props.tooltipText !== undefined && this.props.tooltipText !== "")
            ? <button
              className="btnTooltip" type="button"
              onMouseEnter={this.toggleTooltip}
              onMouseLeave={this.toggleTooltip}
              aria-describedby={`${this.props.ddname}tooltip`}
              onClick={this.toggleTooltip}
              onKeyUp={(event) => this.toggleTooltiponEnter(event)}
              className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon"
              data-tooltip={this.props.id}
              style={{
                background: "white",
                border: "inherit"
              }}
              aria-label={`More information on ${this.props.ddname}`}
              aria-expanded={false}
            >
            </button>
            : ''
        }
        {
          (this.props.helpText !== undefined && this.props.helpText !== "") ? (
            <div className="input-help-msg-section">
              {Translations(this.props.helpText, this.props.lang, this.props.translatedData)}
            </div>
          ) : ''
        }
        <div className="input-error-msg-section" id={this.props.ddname + "-error"} role="alert">
          {this.state.dropDownInvalid ? (
            <React.Fragment>
              <span className="icon icon-circle-delete-solid"></span>
              {this.props.mandatoryMessage}
            </React.Fragment>
          ) : ''}
        </div>
        <Tooltip
          active={this.state.showTooltip}
          position="right"
          arrow="center"
          parent={this.props.id}
          id={`${this.props.ddname}tooltip`}
          role="tooltip"
        >
          <div className="tooltip-content-hintText">
            <span role="status" id={`${this.props.ddname}tooltip`}>{Translations(this.props.tooltipText, this.props.lang, this.props.translatedData)}</span>
          </div>
        </Tooltip>
        <div className="gdocs-clear-float"></div>
        <Modal
          show={this.state.showModal}
          onClose={this.toggleDialog}
          bsClass={"submit-request-modal-content"}
        >
          <ModalBody>
            <p>{Translations(this.props.modalText, this.props.lang, this.props.translatedData)}</p>
          </ModalBody>
        </Modal>
      </div >
    );
  }

  // this change for was added for crash fix of DGT-6804
  // but it is causing options to not load in dropdown, so reverting
  // reverting for DGT-6842
  // shouldComponentUpdate(nextProps, nextStates) {
  //   return JSON.stringify(this.state) !== JSON.stringify(nextStates)
  // }
}

Dropdown.defaultProps = {
  showPleaseSelect: false
}


const mapStateToProps = state => {
  return {
    cases: state.cases,
    countryInfo: state.countryInfo,
    currencyInfo: state.currencyInfo,
    resUrl: state.urls,
    countryInfoData: state.countryInfoData,
    bankNameInfo: state.bankNameInfo,
    accountPaperStatement: state.accountPaperStatement
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setCountryInfo: assocaitions => {
      dispatch(setCountryInfo(assocaitions))
    },
    setCountryInfoData: assocaitions => {
      dispatch(setCountryInfoData(assocaitions))
    },
    setBankNameInfo: assocaitions => {
      dispatch(setBankNameInfo(assocaitions))
    },
    setCurrencyInfo: currencyInfo => {
      dispatch(setCurrencyInfo(currencyInfo))
    },
    resetCountryInfo: () => {
      dispatch(resetCountryInfo())
    },
    resetCurrencyInfo: () => {
      dispatch(resetCurrencyInfo())
    },
    setLanguageFlag: flag => {
      dispatch(setLanguageFlag(flag))
    },
    setAccountPaperStatement: accountPaperStatement => {
      dispatch(setAccountPaperStatement(accountPaperStatement))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
  }
}

const DropdownContainer = connect(mapStateToProps, mapDispatchToProps)(Dropdown);
export default DropdownContainer;


// WEBPACK FOOTER //
// ./src/components/common/Dropdown/DropDown.js